import {
  CHAT_USER,
  ACTIVE_USER,
  FULL_USER,
  ADD_LOGGED_USER,
  CREATE_GROUP,
  IMAGE_FILE,
  VIDEO_FILE,
  DOCUMENT_FILE,
  CHAT_REPLY,
  LOADING_CHAT,
} from "./constants";

const INIT_STATE = {
  active_user: 0,
  image_file: "",
  video_file: "",
  chat_reply: false,
  document_file: {
    name: "",
    size: "",
  },
  users: [],
  loading_chat: false,

  contacts: [
    { id: 1, name: "Albert Rodarte" },
    { id: 2, name: "Allison Etter" },
    { id: 3, name: "Craig Smiley" },
    { id: 4, name: "Daniel Clay" },
    { id: 5, name: "Doris Brown" },
    { id: 6, name: "Iris Wells" },
    { id: 7, name: "Juan Flakes" },
    { id: 8, name: "John Hall" },
    { id: 9, name: "Joy Southern" },
    { id: 10, name: "Mary Farmer" },
    { id: 11, name: "Mark Messer" },
    { id: 12, name: "Michael Hinton" },
    { id: 13, name: "Ossie Wilson" },
    { id: 14, name: "Phillis Griffin" },
    { id: 15, name: "Paul Haynes" },
    { id: 16, name: "Rocky Jackson" },
    { id: 17, name: "Sara Muller" },
    { id: 18, name: "Simon Velez" },
    { id: 19, name: "Steve Walker" },
    { id: 20, name: "Hanah Mile" },
  ],
};

const Chat = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CHAT_USER:
      return { ...state };

    case ACTIVE_USER:
      return {
        ...state,
        active_user: action.payload,
      };

    case IMAGE_FILE:
      return {
        ...state,
        image_file: action.payload,
      };

    case VIDEO_FILE:
      return {
        ...state,
        video_file: action.payload,
      };

    case DOCUMENT_FILE:
      return {
        ...state,
        document_file: action.payload,
      };

    case CHAT_REPLY:
      return {
        ...state,
        chat_reply: action.payload,
      };

    case FULL_USER:
      return {
        ...state,
        users: action.payload,
      };

    case ADD_LOGGED_USER:
      const newUser = action.payload;
      return {
        ...state,
        users: [...state.users, newUser],
      };

    case CREATE_GROUP:
      const newGroup = action.payload;
      return {
        ...state,
        groups: [...state.groups, newGroup],
      };

    case LOADING_CHAT:
      return {
        ...state,
        loading_chat: action.payload,
      };

    default:
      return { ...state };
  }
};

export default Chat;
